var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "new-user box is-centered",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _c("h1", { staticClass: "title is-4 has-text-primary" }, [
        _vm._v("\n    Actualizar Datos.\n  ")
      ]),
      _c("div", { staticClass: "columns is-multiline" }, [
        _c(
          "div",
          { staticClass: "column is-12-mobile is-12-fullhd is-6" },
          [
            _c("AppInputField", {
              attrs: {
                id: "name",
                name: "name",
                label: "Nombre",
                "left-icon": "person",
                placeholder: "Some Else",
                value: _vm.name,
                disabled: _vm.isLoading,
                required: ""
              },
              on: { input: _vm.onChange, change: _vm.onChange }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12-mobile is-12-fullhd is-6" },
          [
            _c("AppInputField", {
              attrs: {
                id: "companyName",
                name: "name",
                label: "Razón social:",
                "left-icon": "label",
                placeholder: "Machete SA de CV",
                value: _vm.companyName,
                disabled: _vm.isLoading,
                required: ""
              },
              on: { input: _vm.onChangeCompany, change: _vm.onChangeCompany }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12-mobile is-12-fullhd is-6" },
          [
            _c("AppInputField", {
              attrs: {
                id: "tradeName",
                name: "tradeName",
                label: "Nombre Comercial:",
                "left-icon": "label",
                placeholder: "Machete",
                value: _vm.tradeName,
                disabled: _vm.isLoading,
                required: ""
              },
              on: { input: _vm.onChangeCompany, change: _vm.onChangeCompany }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12-mobile is-12-fullhd is-6" },
          [
            _c("AppInputField", {
              attrs: {
                id: "employerRegistration",
                name: "employerRegistration",
                label: "Registro Patronal:",
                "left-icon": "label",
                placeholder: "00000012340",
                value: _vm.employerRegistration,
                disabled: _vm.isLoading
              },
              on: { input: _vm.onChangeCompany, change: _vm.onChangeCompany }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12-mobile is-12-fullhd is-6" },
          [
            _c("AppInputRfc", {
              attrs: {
                value: _vm.rfc,
                disabled: _vm.isLoading,
                "valid-icon": false
              },
              on: { input: _vm.onChangeCompany, change: _vm.onChangeCompany }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12-mobile is-12-fullhd is-6" },
          [
            _c("AppInputEmail", {
              attrs: {
                value: _vm.email,
                disabled: _vm.isLoading,
                required: ""
              },
              on: { input: _vm.onChange, change: _vm.onChange }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12-mobile is-12-fullhd is-6" },
          [
            _c("AppInputField", {
              attrs: {
                id: "accountNumber",
                name: "accountNumber",
                label: "Número de cuenta:",
                "left-icon": "label",
                placeholder: "00152356",
                value: _vm.accountNumber,
                disabled: _vm.isLoading
              },
              on: { input: _vm.onChangeCompany, change: _vm.onChangeCompany }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12-mobile is-12-fullhd is-6" },
          [
            _c("AppSelectField", {
              attrs: {
                id: "projectName",
                name: "projectName",
                label: "Proyecto:",
                placeholder: "Selecciona una opción",
                value: _vm.projectName,
                disabled: _vm.isLoading,
                options: _vm.projectOptions
              },
              on: { input: _vm.onChangeCompany, change: _vm.onChangeCompany }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12-mobile is-12-fullhd is-6" },
          [
            _c("AppSelectField", {
              attrs: {
                id: "multiUser",
                name: "multiUser",
                label: "Multi usuario:",
                placeholder: "Selecciona una opción",
                value: _vm.multiUser,
                disabled: _vm.isLoading,
                options: _vm.multiUserOptions
              },
              on: { input: _vm.onChangeCompany, change: _vm.onChangeCompany }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12-mobile is-12-fullhd is-6" },
          [
            _c("AppInputPhoneNumber", {
              attrs: {
                value: _vm.phoneNumber,
                disabled: _vm.isLoading,
                "valid-icon": false
              },
              on: { input: _vm.onChange, change: _vm.onChange }
            })
          ],
          1
        )
      ]),
      _c("ButtonSubmit", {
        attrs: { "is-loading": _vm.isLoading, text: "Actualizar Datos" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }